import { render } from "./ApplicationProfile.vue?vue&type=template&id=644e1b62&ts=true"
import script from "./ApplicationProfile.vue?vue&type=script&lang=ts"
export * from "./ApplicationProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__